import { CodeItemWire } from 'app/area/codetable/item/types';
import { CodeItem } from 'app/area/codetable/item/types-store';
import { CodeListItem } from 'app/area/codetable/list/types-store';
import { RiskMatrixSortOrderType } from 'app/area/risk-matrix-administration/constants';
import { ComplexValue } from 'app/types-shared';

export interface RiskMatrixState {
  type: ComplexValue<number>;
  previousType: ComplexValue<number>;
  selectedCellId: number;
  axes: RiskMatrixAxes;
  cells: RiskMatrixCell[];
  thirdAxisItem: ComplexValue<number>;
  modifiedCells: RiskMatrixCell[];
  details: RiskMatrixDetails;
  riskAreas: CodeListItem[];
  caseTypes: ComplexValue<number>[];
  savingCells: boolean;
  fetchingAxes: boolean;
  fetchingCells: boolean;
  fetchingDetails: boolean;
  fetchingRiskAreas: boolean;
  fetchingCaseTypes: boolean;
}

export interface RiskMatrixDetails extends CodeItem {
  xAxisCodetableId: number;
  yAxisCodetableId: number;
  zAxisCodetableId?: number;
  xAxisSortOrderType: number;
  yAxisSortOrderType: number;
  zAxisSortOrderType?: number;
}

export interface RiskMatrixDetailsWire extends CodeItemWire {
  xAxisCodetable?: number;
  yAxisCodetable?: number;
  zAxisCodetable?: number;
  xAxisSortOrderType?: number;
  yAxisSortOrderType?: number;
  zAxisSortOrderType?: number;
}

export type RiskMatrixAxes = RiskMatrixAxis[];

export interface RiskMatrixAxis {
  codetableId: number;
  items: CodeListItem[];
  sortOrderType?: RiskMatrixSortOrderType;
}

export type RiskMatrixCells = RiskMatrixCell[];

export interface RiskMatrixCell {
  id: number;
  riskArea: number;
  riskWeight: number;
  [RiskMatrixCellProperty.recurrence]: number;
  [RiskMatrixCellProperty.severity]: number;
  [RiskMatrixCellProperty.likelihood]: number;
}

export enum RiskMatrixCellProperty {
  severity = 'severity',
  recurrence = 'recurrence',
  likelihood = 'likelihood'
}

export interface SetCellPayload {
  xAxisItemIndex: number;
  yAxisItemIndex: number;
  axes: RiskMatrixAxes;
  cells: RiskMatrixCell[];
  thirdAxisItem?: ComplexValue<number>;
}

export interface UpdateSelectedCellPayload {
  patch: Partial<RiskMatrixCell>;
  selectedCellId: number;
  cells: RiskMatrixCell[];
  modifiedCells: RiskMatrixCell[];
}
